import { UserException } from '@/domain/user/exception/UserException'

export class EmailTakenException extends UserException {

}
